import type { ReactNode } from 'react';

import { cn } from '@/utils/cn';

interface SectionCardProps {
  title?: ReactNode;
  icon?: ReactNode;
  count?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
  /** When true, removes the inner padding (use with FieldGrid which handles its own padding). */
  dense?: boolean;
  className?: string;
  bodyClassName?: string;
  id?: string;
}

export function SectionCard({
  title,
  icon,
  count,
  actions,
  children,
  dense,
  className,
  bodyClassName,
  id,
}: SectionCardProps) {
  return (
    <section className={cn('section-card', className)} id={id}>
      {title && (
        <div className="section-head">
          {icon && <span className="sh-icon">{icon}</span>}
          <span>{title}</span>
          {count !== undefined && count !== null && <span className="sh-count">· {count}</span>}
          {actions && <span className="sh-actions">{actions}</span>}
        </div>
      )}
      <div className={cn('section-body', dense && 'dense', bodyClassName)}>{children}</div>
    </section>
  );
}
